<template>
  <div :class="type === 'pc' ? 'footer-pc' : 'footer'">
    <div class="footer-box">
      <div class="footer-info">
        <span>{{ $t('common.CustomsoftheMacaoSpecialAdministrativeRegion') }}</span>
        <span>{{ $t('common.AddressMacau') }}</span>
        <span>{{ $t('common.Email') }}：info@customs.gov.mo</span>
        <span>{{ $t('common.Phone') }}：（+853）28559944</span>
        <span>{{ $t('common.Fax') }}：（+853）28371136</span>
      </div>
      <div class="footer-more">
        <div class="footer-link">
          <a @click="handleOpen('aboutMe')">{{ $t('common.aboutus') }}</a>
          <a style="margin:0 6px;" @click="handleOpen('callMe')">{{ $t('common.Contactus') }}</a>
          <a @click="handleOpen('other')">{{ $t('common.Useandprivacypolicy') }}</a>
        </div>
        <span class="footer-social">{{ $t('common.2020') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Footer",
    props: {
      type: String
    },
    methods: {
      handleOpen (type) {
        this.$emit("open", type);
      }
    }
  };
</script>
<style lang="scss" scope>
.footer {
  margin: -20px;
  margin-top: -40px;
  .footer-box {
    position: relative;
    width: 100%;
    // height: 480px;
    height: 550px;
    background-image: url("../../assets/footer.png");
    font-family: PingFang SC;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    padding: 40px 0;
    top: 50px;
    .footer-info {
      width: 532px;
      height: 240px;
      line-height: 40px;
      letter-spacing: 0;
      color: #fff;
      margin: auto;
      display: flex;
      flex-direction: column;
    }
    .footer-more {
      min-width: 439px;
      height: 80px;
      line-height: 40px;
      letter-spacing: 0;
      position: absolute;
      bottom: 150px;
      // 100
      // right: 109px;
      right: 5px;
      color: #337ab7;
      .footer-link {
        display: flex;
        justify-content: space-between;
      }
      .footer-social {
        display: flex;
        justify-content: flex-end;
        color: #fff;
      }
    }
  }
}
.footer-pc {
  padding-top: 20px;  /* no */
  width: 100%;
  .footer-box {
    position: relative;
    width: 100%;
    height: 304px; /* no */
    background-image: url("../../assets/footer-pc.png");
    font-family: PingFang SC;
    font-size: 14px; /* no */
    font-weight: normal;
    font-stretch: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    .footer-info {
      width: 70%;
      display: flex;
      flex-direction: column;
      font-family: Microsoft YaHei;
      font-size: 14px; /* no */
      font-weight: normal;
      font-stretch: normal;
      line-height: 22px; /* no */
      letter-spacing: 0;
      color: #fff;
    }
    .footer-more {
      min-width: 218px; /* no */
      height: 41px; /* no */
      line-height: 22px; /* no */
      letter-spacing: 0;
      position: absolute;
      bottom: 136px; /* no */
      right: 109px; /* no */
      color: #337ab7;
      .footer-link {
        display: flex;
        justify-content: space-between;
      }
      .footer-social {
        display: flex;
        justify-content: flex-end;
        color: #fff;
      }
    }
  }
}
</style>